import { MicroFrontEnd } from 'properties-ui-common'
import apiConfig from '../../../apiConfig'

export const VaEdit = () => {
  return <MicroFrontEnd name="VaEdit" src={apiConfig.microFrontEnds.VaEdit} />
}

export default VaEdit
